import { FC, ReactElement } from 'react';

import { Page, Wrapper } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet, ConnectedRequestResetPasswordForm } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './RequestResetPasswordPage.scss';

interface RequestResetPasswordPageProps {
    className?: string;
}

export const RequestResetPasswordPage: FC<RequestResetPasswordPageProps> = ({
    className = '',
}): ReactElement => (
    <Page className={`request-reset-password-page ${className}`}>
        <ConnectedPageHelmet appRoute={AppRoute.requestResetPassword} />

        <Wrapper className="request-reset-password-page__wrapper">
            <ConnectedRequestResetPasswordForm className="request-reset-password-page__password-form" />
        </Wrapper>

        <ConnectedBlockRenderer appRoute={AppRoute.requestResetPassword} className="request-reset-password-page__section" />
    </Page>
);
